import React from 'react';

export const ResourceDownload = (props) => {

    const sc = props.slice.primary;


    return (
        <section className="gutter sm top res-sec">
            <div className="res-section wrapper">
                <div className="flex justify-center items-center">
                    <a href={sc.pdf.url} target="_blank" rel="noreferrer" className="btn bg-yellow text-lg pr-8 pl-5 ungated">{sc.button_label}</a>
                </div>
            </div>
        </section>
    );
}

